import React from "react";
import EngineDrillDownPage from "../../../../components/pages/_new/super/engines/EngineDrillDownPage";

const AdDetailPage = () => <EngineDrillDownPage engineType="AD_ENGINE" />;

export default AdDetailPage;
